import { AgenciesStateInterface } from '.';

function state(): AgenciesStateInterface {
  return {
    agencies: [],
  };
}

export default state;
